import { useMutation, useQueryCache } from "react-query";
import { postAdminNewChat } from "../../api";
import { notify } from "../../../../../common/helpers";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { API_KEY_GET_ADMIN_CHATS } from "../../helpers";

export const usePostAdminNewChat = () => {
  const queryCache = useQueryCache();
  const successMsg = _t("new_msg_send");

  return useMutation(postAdminNewChat, {
    onSuccess: (data, variables) => {
      notify("success", successMsg);
      queryCache.invalidateQueries(API_KEY_GET_ADMIN_CHATS);
    },
  });
};
